/** Remove máscara; não valida dígitos verificadores. */
export function somenteDigitosCnpj(raw: string | undefined | null): string {
  if (!raw) return "";
  return raw.replace(/\D/g, "");
}

/** CNPJ para URL/API: exatamente 14 dígitos após normalizar. */
export function normalizeCnpjParaApi(raw: string | undefined | null): string {
  const d = somenteDigitosCnpj(raw);
  return d.length === 14 ? d : "";
}

export function cnpjTem14Digitos(digits: string): boolean {
  return /^\d{14}$/.test(digits);
}

export function formatCnpjLeitura(cnpjDigits: string): string {
  const d = somenteDigitosCnpj(cnpjDigits);
  if (d.length !== 14) return cnpjDigits;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(
    8,
    12
  )}-${d.slice(12, 14)}`;
}
